export const SET_ACTIVE_USER_ID = "SET_ACTIVE_USER_ID";
export const SET_INPUT_VALUE = "SET_INPUT_VALUE";
export const SET_CURSOR_POSITION = "SET_CURSOR_POSITION";
export const SET_EMOJI = "SET_EMOJI";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const SET_FILTER_VALUE = "SET_FILTER_VALUE";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const TOGGLE_EMOJI_PICKER = "TOGGLE_EMOJI_PICKER";
export const ACTIVATE_SEND_BUTTON = "ACTIVATE_SEND_BUTTON";
export const DELETE_MESSAGE = "DELETE_MESSAGE";
export const TOGGLE_MORE = "TOGGLE_MORE";
export const TOGGLE_EDIT_MODE = "TOGGLE_EDIT_MODE";
export const SAVE_EDITS = "SAVE_EDITS";
